define("shared/utils/analytics/constants/features", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.FEATURES = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * List of all analytics features
   */
  const FEATURES = _exports.FEATURES = ['analyticsPerformanceReport', 'analyticsStandard', 'analyticsTableRedesign', 'backfillAnalytics', 'clickTracking', 'conversations', 'export', 'facebook', 'hashtag', 'hashtagTrends', 'instagramReels', 'libAnalyticsHeatmap', 'linkedinAnalytics', 'linkinbioEmbeddable', 'linkinbioExtendedAnalytics', 'longerAnalytics', 'longerAnalyticsTable', 'performanceReport', 'pinterest', 'pinterestClickTracking', 'profileCategorization', 'twitter', 'twitterClickTracking', 'tiktokAnalytics', 'facebookPostPerformance', 'threadsAnalytics'];
  var _default = _exports.default = FEATURES;
});